<div *ngIf="showNewToday; else oldToday">
  <section
    *ngIf="resTodayTrip && resTodayTripContent"
    class="flyout-today-section"
    tabindex="1"
  >
    <section class="flight-information-section w-100">
      <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
        <div class="flight-details">
          <a
            (click)="mytripsTodayClick($event)"
            [attr.target]="
              resTodayTripContent?.arrowFlightDetailsOpenNewTab === 'true'
                ? '_blank'
                : '_self'
            "
            [ngClass]="disableViewLink ? 'disableViewLink' : ''"
            class="w-100"
            href="javascript:void(0)"
            ng-disabled="disableViewLink"
            role="link"
          >
            <form
              #flyoutTodayMytripsForm
              *ngIf="resTodayTrip.viewTripDetails"
              [action]="formActionFlight"
              id="flyout-todayTrip-link"
              method="POST"
              novalidate
            >
              <input
                name="confirmationNo"
                type="hidden"
                value="{{ resTodayTrip?.recordLocator }}"
              />
              <input
                name="firstName"
                type="hidden"
                value="{{ resTodayTrip?.firstName }}"
              />
              <input
                name="lastName"
                type="hidden"
                value="{{ resTodayTrip?.lastName }}"
              />
              <input name="flagFromMyProfile" type="hidden" value="Y" />
              <input name="interstitial" type="hidden" value="true" />
            </form>
            <div class="row no-gutters">
              <div class="flight-number flight-labels">
                <span class="p-0 col-xl-2 flight-number-label">
                  {{ resTodayTrip.mktCarrierCode }}
                  {{ resTodayTrip.mktFlightNumber }}
                </span>
                <span
                  *ngIf="resTodayTrip.optCarrierCode"
                  class="operated-by p-0 col-xl-10"
                >
                  {{ resTodayTripContent?.operatedby }}
                  {{ resTodayTrip.optCarrierCode }}
                </span>
              </div>
            </div>
            <div class="row no-gutters flight-depart-arrive">
              <div class="col-9 col-sm-9 col-md-9 col-xl-9 col-lg-9 d-flex">
                <div
                  class="col-5 col-sm-5 col-md-5 col-xl-5 col-lg-5 p-0 d-inline"
                >
                  <div class="airport text-left departure-airport">
                    {{ resTodayTrip.departureCityCode }}
                  </div>
                  <div class="depart-arrive text-left">
                    <p class="text-adjust">
                      {{ resTodayTripContent?.depart }}
                      <span
                        *ngIf="resTodayTrip.actFlightDepartureTime !== null"
                        class="depart-arrive-time"
                      >
                        {{ resTodayTrip.actFlightDepartureTime }}
                      </span>
                      <span
                        *ngIf="resTodayTrip.actFlightDepartureTime === null"
                        class="depart-arrive-time"
                      >
                        {{ resTodayTrip.schedFlightDepartureTime }}
                      </span>
                    </p>
                    <span
                      *ngIf="resTodayTrip.actFlightDepartureTime !== null"
                      class="actual-time"
                    >
                      ({{ resTodayTripContent?.was }}
                      {{ resTodayTrip.schedFlightDepartureTime }})
                    </span>
                  </div>
                </div>
                <div
                  class="col-2 col-sm-2 col-md-2 col-xl-2 col-lg-2 p-0 mt-3 d-inline"
                >
                  <div class="dark-triangle"></div>
                </div>
                <div
                  class="col-5 col-sm-5 col-md-5 col-xl-5 col-lg-5 p-0 d-inline"
                >
                  <div class="airport text-left arrival-airport">
                    {{ resTodayTrip.arrivalCityCode }}
                  </div>
                  <div class="depart-arrive text-left">
                    <p class="text-adjust">
                      {{ resTodayTripContent?.arrive }}
                      <span
                        *ngIf="resTodayTrip.actFlightArrivalTime !== null"
                        class="depart-arrive-time"
                      >
                        {{ resTodayTrip.actFlightArrivalTime }}
                      </span>
                      <span
                        *ngIf="resTodayTrip.actFlightArrivalTime === null"
                        class="depart-arrive-time"
                      >
                        {{ resTodayTrip.schedFlightArrivalTime }}
                      </span>
                    </p>
                    <span *ngIf="resTodayTrip.actFlightArrivalTime !== null">
                      ({{ resTodayTripContent?.was }}
                      {{ resTodayTrip.schedFlightArrivalTime }})
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-3 col-sm-3 col-md-3 col-xl-3 col-lg-3">
                <a
                  (click)="mytripsTodayClick($event)"
                  *ngIf="!disableViewLink"
                  aria-hidden="true"
                  class="right-caret mt-3"
                  href="javascript:void(0)"
                  role="link"
                >
                  <form
                    #flyoutTodayMytripsForm
                    *ngIf="resTodayTrip.viewTripDetails"
                    [action]="formActionFlight"
                    id="flyout-todayTrip-link"
                    method="POST"
                    novalidate
                  >
                    <input
                      name="confirmationNo"
                      type="hidden"
                      value="{{ resTodayTrip?.recordLocator }}"
                    />
                    <input
                      name="firstName"
                      type="hidden"
                      value="{{ resTodayTrip?.firstName }}"
                    />
                    <input
                      name="lastName"
                      type="hidden"
                      value="{{ resTodayTrip?.lastName }}"
                    />
                    <input name="flagFromMyProfile" type="hidden" value="Y" />
                    <input name="interstitial" type="hidden" value="true" />
                  </form>
                </a>
              </div>
            </div>
            <span *ngIf="!disableViewLink" class="sr-only">
              {{ resTodayTrip.departureCityCode }} -
              {{ resTodayTrip.arrivalCityCode }} Trip details
            </span>
          </a>
        </div>
        <!-- <div class="d-block line-breaker">
                </div> -->
      </div>
    </section>

    <section
      *ngIf="resAcctSumDetails && !showIropModel && resTodayTripContent"
      class="boarding-information-section w-100"
    >
      <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
        <div class="flyout-medallion-details">
          <div class="row no-gutters flyout-button-container">
            <a
              *ngIf="resTodayTrip.checkedIn"
              [attr.target]="
                resTodayTripContent?.viewBoardingPassOpenNewTab === 'true'
                  ? '_blank'
                  : '_self'
              "
              class="col-sm-10 col-md-10 col-xl-10 col-lg-10 flyout-button view-pass"
              href="{{ hrefURL }}{{ resTodayTrip.checkinLink }}"
              role="button"
            >
              {{ resTodayTripContent?.viewBoardingPass }}
              <span
                *ngIf="
                  resTodayTripContent?.viewBoardingPassOpenNewTab === 'true';
                  else viewBoardingSameWindow
                "
                class="sr-only"
              >
                Open in new window
              </span>
              <ng-template #viewBoardingSameWindow>
                <span class="sr-only">Open in same window</span>
              </ng-template>
            </a>
            <a
              *ngIf="resTodayTrip.checkinEligible && !resTodayTrip.checkedIn"
              [attr.target]="
                resTodayTripContent?.checkinOpenNewTab === 'true'
                  ? '_blank'
                  : '_self'
              "
              class="col-sm-12 col-md-12 col-xl-12 col-lg-12 flyout-button checkIn check-in-button"
              href="{{ hrefURL }}{{ resTodayTrip.checkinLink }}"
              role="button"
            >
              {{ resTodayTripContent?.checkinLabel }}
              <span
                *ngIf="
                  resTodayTripContent?.checkinOpenNewTab === 'true';
                  else checkinSameWindow
                "
                class="sr-only"
              >
                Open in new window
              </span>
              <ng-template #checkinSameWindow>
                <span class="sr-only">Open in same window</span>
              </ng-template>
            </a>
          </div>
          <div class="row no-gutters">
            <div class="col-5 col-sm-5 col-md-5 col-xl-5 col-lg-5">
              <div class="flight-labels status-gate">
                {{ resTodayTripContent?.statusLabel }}
              </div>
              <div
                [ngClass]="
                  getStatusColorChange(
                    resTodayTrip.flightStatus &&
                      resTodayTrip.flightStatus.statusColor
                      ? resTodayTrip.flightStatus.statusColor
                      : null
                  )
                "
                class="row no-gutters mt-1 flight-status-icon"
              >
                <div class="col-2 col-sm-2 col-md-2 col-xl-2 col-lg-2">
                  <img
                    [ngClass]="{
                      'd-none':
                        resTodayTrip.flightStatus &&
                        resTodayTrip.flightStatus.status &&
                        (resTodayTrip.flightStatus?.status | lowercase).indexOf(
                          'not'
                        ) === -1
                          ? false
                          : true
                    }"
                    alt="flight status"
                    class="aero-status"
                    src="/content/dam/delta-applications/header/clear.gif"
                  />
                </div>
                <div
                  [ngClass]="
                    resTodayTrip.flightStatus &&
                    resTodayTrip.flightStatus.status &&
                    (resTodayTrip.flightStatus?.status | lowercase).indexOf(
                      'not'
                    ) === -1
                      ? 'ml-4'
                      : 'noStatus'
                  "
                  class="col-10 col-sm-10 col-md-10 col-xl-10 col-lg-10 p-0 status-text text-capitalize text-left"
                >
                  {{
                    resTodayTrip.flightStatus &&
                    resTodayTrip.flightStatus.status &&
                    (resTodayTrip.flightStatus?.status | lowercase).indexOf(
                      'not'
                    ) === -1
                      ? (resTodayTrip.flightStatus.status | lowercase)
                      : '--'
                  }}
                </div>
              </div>
            </div>
            <div class="col-7 col-sm-7 col-md-7 col-xl-7 col-lg-7 pl-3">
              <div class="flight-labels status-gate">
                {{ resTodayTripContent?.gateLabel }}
              </div>
              <div class="mt-1">
                <span class="gate-code">
                  {{
                    resTodayTrip.flightStatus && resTodayTrip.flightStatus.gate
                      ? resTodayTrip.flightStatus.gate
                      : '--'
                  }}
                </span>
                <span class="terminal-label domestic-term pl-1">
                  {{ resTodayTrip?.flightStatus?.terminal }}
                </span>
              </div>
            </div>
          </div>
          <div class="row no-gutters flyout-details mt-3">
            <div class="col-8 col-sm-8 col-md-8 col-xl-8 col-lg-8">
              <div
                class="flyout-label pb-2 text-left member-type text-uppercase"
              >
                {{ getMemberDesc }}
              </div>
              <div class="flyout-value">
                {{ resAcctSumDetails.firstName }}
                {{
                  resAcctSumDetails.middleName
                    ? resAcctSumDetails.middleName
                    : ''
                }}
                {{ resAcctSumDetails.lastName }}
              </div>
            </div>
            <div class="col-4 col-sm-4 col-md-4 col-xl-4 col-lg-4">
              <div class="flyout-label pb-2 text-left seat-label">
                {{ resTodayTripContent?.seatLabel }}
              </div>
              <div class="flyout-value">
                {{ resTodayTrip.seatNumber ? resTodayTrip.seatNumber : '--' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section *ngIf="showIropModel && resTodayTripContent" class="irop-model">
      <div
        [ngClass]="
          getStatusColorChange(
            resTodayTrip.flightStatus && resTodayTrip.flightStatus.statusColor
              ? resTodayTrip.flightStatus.statusColor
              : null
          )
        "
        class="irop-model-highlight"
      ></div>
      <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
        <div
          #iropmsg
          *ngIf="iropErrorMsg"
          [ngClass]="getIROPColorChange(resTodayTrip.iropMessage)"
          class="irop-status-message"
          id="irop_msg"
          role="alert"
          tabindex="0"
        >
          <div class="mr-2 irop-error-icon">
            <img
              alt="irop status icon"
              class="irop-status"
              src="/content/dam/delta-applications/header/clear.gif"
            />
          </div>
          <h3 class="irop-heading">{{ iropErrorMsg.errorMessageTitle }}</h3>

          <div class="irop-message">
            {{ iropErrorMsg.errorMessageDescription }}
          </div>
        </div>
        <div class="row no-gutters irop-button-container">
          <a
            (click)="closeIropModel()"
            *ngIf="resTodayTrip.remainOnFlight"
            class="flyout-button checkIn remain-same"
            href="javascript:void(0)"
            role="button"
          >
            {{ resTodayTripContent?.remainOnFlight }}
          </a>

          <a
            (click)="mytripsTodayClick($event)"
            *ngIf="resTodayTrip.viewTripDetails && !disableViewLink"
            [attr.target]="
              resTodayTripContent?.viewTripDetailsOpenNewTab === 'true'
                ? '_blank'
                : '_self'
            "
            class="flyout-button checkIn view-trip-button"
            href="javascript:void(0)"
            role="button"
          >
            {{ resTodayTripContent?.viewTripDetails }}
            <span class="sr-only">Open in same window</span>
            <span
              *ngIf="
                resTodayTripContent?.viewTripDetailsOpenNewTab === 'true';
                else viewTripDetailsOpenSameTab
              "
              class="sr-only"
            >
              Open in new window
            </span>
            <ng-template #viewTripDetailsOpenSameTab>
              <span class="sr-only">Open in same window</span>
            </ng-template>
            <form
              #flyoutTodayMytripsForm
              [action]="formActionFlight"
              id="flyout-todayTrip-link"
              method="POST"
              novalidate
            >
              <input
                name="confirmationNo"
                type="hidden"
                value="{{ resTodayTrip?.recordLocator }}"
              />
              <input
                name="firstName"
                type="hidden"
                value="{{ resTodayTrip?.firstName }}"
              />
              <input
                name="lastName"
                type="hidden"
                value="{{ resTodayTrip?.lastName }}"
              />
              <input name="flagFromMyProfile" type="hidden" value="Y" />
              <input name="interstitial" type="hidden" value="true" />
            </form>
          </a>
          <button
            class="flyout-button alternate-button pt-0 mb-lg-3"
            id="btnSubmit"
            *ngIf="resTodayTrip.findOtherFlights && awsFlag"
            (click)="findAlternateFlight()"
          >
            {{ resTodayTripContent?.findAlternate }}
            <span
              *ngIf="
                resTodayTripContent?.findAlternateOpenNewTab === 'true';
                else findAlternateOpenSameTab
              "
              class="sr-only"
            >
              Open in new window
            </span>
            <ng-template #findAlternateOpenSameTab>
              <span class="sr-only">Open in same window</span>
            </ng-template>
          </button>
          <form
            (ngSubmit)="onSubmit($event)"
            *ngIf="resTodayTrip.findOtherFlights && !awsFlag"
            [action]="formAction"
            [attr.target]="
              resTodayTripContent?.findAlternateOpenNewTab === 'true'
                ? '_blank'
                : '_self'
            "
            method="POST"
            novalidate
          >
            <button
              class="flyout-button alternate-button pt-0 mb-lg-3"
              id="btnSubmit"
              type="submit"
              *ngIf="resTodayTrip.findOtherFlights"
            >
              {{ resTodayTripContent?.findAlternate }}
              <span
                *ngIf="
                  resTodayTripContent?.findAlternateOpenNewTab === 'true';
                  else findAlternateOpenSameTab
                "
                class="sr-only"
              >
                Open in new window
              </span>
              <ng-template #findAlternateOpenSameTab>
                <span class="sr-only">Open in same window</span>
              </ng-template>
            </button>
            <input
              id="recordLocator"
              name="recordLocator"
              type="hidden"
              value="{{ resTodayTrip?.recordLocator }}"
            />
            <input
              id="firstName"
              name="firstName"
              type="hidden"
              value="{{ resTodayTrip?.firstName }}"
            />
            <input
              id="lastName"
              name="lastName"
              type="hidden"
              value="{{ resTodayTrip?.lastName }}"
            />
          </form>
        </div>
        <button
          (click)="closeIropModel()"
          *ngIf="!hideIROPClose"
          class="irop-flyout-close float-right circle-outline"
          type="button"
        >
          <span class="sr-only">close</span>
        </button>
      </div>
    </section>
  </section>
  <section
    *ngIf="
      !resTodayTrip &&
      noUpcomingTripContent &&
      aemErrorMsgDetails &&
      resTodayTripContent
    "
    class="no-upcoming-trips-section h-100 d-flex align-items-center text-center"
    tabindex="1"
  >
    <div class="row w-100">
      <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
        <div class="col-12" tabindex="0">
          <img
            alt="Flight Icon"
            aria-labelledby="Flight Icon"
            class="round-flight-icon"
            src="/content/dam/delta-applications/header/clear.gif"
          />
          <p class="mb-3 mt-4">
            {{ aemErrorMsgDetails?.errorMessageDescription }}
          </p>
          <p class="mb-0">
            <a
              (click)="tripNavItem('book')"
              class="link-to-book"
              href="javascript:void(0);"
              role="link"
            >
              {{ resTodayTripContent?.bookFlightLink }}
            </a>
            <span class="va-notrip-space">or</span>
            <a
              (click)="tripNavItem('mytrips')"
              class="link-to-mytrips"
              href="javascript:void(0);"
              role="link"
            >
              {{ resTodayTripContent?.myTripsLink }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    *ngIf="!resTodayTrip && !noUpcomingTripContent && aemErrorMsgDetails"
    class="no-upcoming-trips-section d-flex align-items-center text-center"
    tabindex="1"
  >
    <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
      <div class="acctvty-error-container container-fluid p-0">
        <div class="col text-center service-error-content p-0">
          <p>
            <span class="icon-alert-icon">
              <span class="path1"></span>
              <span class="path2"></span>
            </span>
            {{ aemErrorMsgDetails?.errorMessageDescription }}.
          </p>
        </div>
      </div>
    </div>
  </section>
</div>
<ng-template #oldToday>
  <section
    *ngIf="resTodayTrip && resTodayTripContent"
    class="flyout-today-section vsToday"
    tabindex="1"
  >
    <section class="flight-information-section w-100">
      <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
        <div class="flight-details">
          <a
            [attr.target]="
              resTodayTripContent?.arrowFlightDetailsOpenNewTab === 'true'
                ? '_blank'
                : '_self'
            "
            [ngClass]="disableViewLink ? 'disableViewLink' : ''"
            class="w-100"
            href="{{ resTodayTrip.viewTripDetails }}"
            ng-disabled="disableViewLink"
            role="link"
          >
            <div class="row no-gutters">
              <div class="flight-number flight-labels">
                <span class="p-0 col-xl-2">
                  {{ resTodayTrip.mktCarrierCode }}
                  {{ resTodayTrip.mktFlightNumber }}
                </span>
                <span
                  *ngIf="resTodayTrip.optCarrierCode"
                  class="operated-by p-0 col-xl-10"
                >
                  {{ resTodayTripContent?.operatedby }}
                  {{ resTodayTrip.optCarrierCode }}
                </span>
              </div>
            </div>
            <div class="row no-gutters flight-depart-arrive">
              <div
                class="col-10 col-sm-10 col-md-10 col-xl-10 col-lg-10 d-flex"
              >
                <div
                  class="col-5 col-sm-5 col-md-5 col-xl-5 col-lg-5 p-0 d-inline"
                >
                  <div class="airport text-left">
                    {{ resTodayTrip.departureCityCode }}
                  </div>
                  <div class="depart-arrive text-left">
                    <p class="text-adjust">
                      {{ resTodayTripContent?.depart }}
                      <span
                        *ngIf="resTodayTrip.actFlightDepartureTime !== null"
                        class="depart-arrive-time"
                      >
                        {{ resTodayTrip.actFlightDepartureTime }}
                      </span>
                      <span
                        *ngIf="resTodayTrip.actFlightDepartureTime === null"
                        class="depart-arrive-time"
                      >
                        {{ resTodayTrip.schedFlightDepartureTime }}
                      </span>
                    </p>
                    <span
                      *ngIf="resTodayTrip.actFlightDepartureTime !== null"
                      class="actual-time"
                    >
                      ({{ resTodayTripContent?.was }}
                      {{ resTodayTrip.schedFlightDepartureTime }})
                    </span>
                  </div>
                </div>
                <div
                  class="col-2 col-sm-2 col-md-2 col-xl-2 col-lg-2 p-0 mt-3 d-inline"
                >
                  <div class="dark-triangle"></div>
                </div>
                <div
                  class="col-5 col-sm-5 col-md-5 col-xl-5 col-lg-5 p-0 d-inline vs-arrive"
                >
                  <div class="airport text-left">
                    {{ resTodayTrip.arrivalCityCode }}
                  </div>
                  <div class="depart-arrive text-left">
                    <p class="text-adjust">
                      {{ resTodayTripContent?.arrive }}
                      <span
                        *ngIf="resTodayTrip.actFlightArrivalTime !== null"
                        class="depart-arrive-time"
                      >
                        {{ resTodayTrip.actFlightArrivalTime }}
                      </span>
                      <span
                        *ngIf="resTodayTrip.actFlightArrivalTime === null"
                        class="depart-arrive-time"
                      >
                        {{ resTodayTrip.schedFlightArrivalTime }}
                      </span>
                    </p>
                    <span *ngIf="resTodayTrip.actFlightArrivalTime !== null">
                      ({{ resTodayTripContent?.was }}
                      {{ resTodayTrip.schedFlightArrivalTime }})
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-2 col-sm-2 col-md-2 col-xl-2 col-lg-2">
                <a
                  *ngIf="!disableViewLink"
                  aria-hidden="true"
                  class="right-caret mt-3"
                  href="{{ hrefURL }}{{ resTodayTrip.viewTripDetails }}"
                  role="link"
                ></a>
              </div>
            </div>
            <span *ngIf="!disableViewLink" class="sr-only">
              {{ resTodayTrip.departureCityCode }} -
              {{ resTodayTrip.arrivalCityCode }} Trip details
            </span>
          </a>
        </div>
        <!--<div class="d-block line-breaker">
            </div>-->
      </div>
    </section>

    <section
      *ngIf="resAcctSumDetails && !showIropModel && resTodayTripContent"
      class="boarding-information-section w-100"
    >
      <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
        <div
          [ngClass]="getClassNames(resAcctSumDetails.membershipLevel)"
          class="flyout-medallion-details"
        >
          <div class="row no-gutters pl-5 pt-5 flyout-button-container">
            <a
              *ngIf="resTodayTrip.checkedIn"
              [attr.target]="
                resTodayTripContent?.viewBoardingPassOpenNewTab === 'true'
                  ? '_blank'
                  : '_self'
              "
              class="col-sm-10 col-md-10 col-xl-10 col-lg-10 flyout-button view-pass"
              href="{{ hrefURL }}{{ resTodayTrip.checkinLink }}"
              role="button"
            >
              {{ resTodayTripContent?.viewBoardingPass }}
              <span
                *ngIf="
                  resTodayTripContent?.viewBoardingPassOpenNewTab === 'true';
                  else viewBoardingSameWindow
                "
                class="sr-only"
              >
                Open in new window
              </span>
              <ng-template #viewBoardingSameWindow>
                <span class="sr-only">Open in same window</span>
              </ng-template>
            </a>
            <a
              (keydown.tab)="focusOutFunctionAx($event)"
              *ngIf="resTodayTrip.checkinEligible && !resTodayTrip.checkedIn"
              [attr.target]="
                resTodayTripContent?.checkinOpenNewTab === 'true'
                  ? '_blank'
                  : '_self'
              "
              class="col-sm-10 col-md-10 col-xl-10 col-lg-10 flyout-button checkIn check-in-button"
              href="{{ hrefURL }}{{ resTodayTrip.checkinLink }}"
              role="button"
            >
              {{ resTodayTripContent?.checkinLabel | uppercase }}
              <span
                *ngIf="
                  resTodayTripContent?.checkinOpenNewTab === 'true';
                  else checkinSameWindow
                "
                class="sr-only"
              >
                Open in new window
              </span>
              <ng-template #checkinSameWindow>
                <span class="sr-only">Open in same window</span>
              </ng-template>
            </a>
          </div>
          <div class="row no-gutters vs-status">
            <div class="col-5 col-sm-5 col-md-5 col-xl-5 col-lg-5">
              <div class="flight-labels status-gate">
                {{ resTodayTripContent?.statusLabel }}
              </div>
              <div
                [ngClass]="
                  getStatusColorChange(
                    resTodayTrip.flightStatus &&
                      resTodayTrip.flightStatus.statusColor
                      ? resTodayTrip.flightStatus.statusColor
                      : null
                  )
                "
                class="mt-1 flight-status-icon"
              >
                <div class="col-2 col-sm-2 col-md-2 col-xl-2 col-lg-2">
                  <img
                    [ngClass]="{
                      'd-none':
                        resTodayTrip.flightStatus &&
                        resTodayTrip.flightStatus.status &&
                        (resTodayTrip.flightStatus?.status | lowercase).indexOf(
                          'not'
                        ) === -1
                          ? false
                          : true
                    }"
                    alt="flight status"
                    class="aero-status"
                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                  />
                </div>
                <div
                  [ngClass]="
                    resTodayTrip.flightStatus &&
                    resTodayTrip.flightStatus.status &&
                    (resTodayTrip.flightStatus?.status | lowercase).indexOf(
                      'not'
                    ) === -1
                      ? 'ml-4'
                      : 'noStatus'
                  "
                  class="col-10 col-sm-10 col-md-10 col-xl-10 col-lg-10 p-0 status-text text-capitalize text-left"
                >
                  {{
                    resTodayTrip.flightStatus &&
                    resTodayTrip.flightStatus.status &&
                    (resTodayTrip.flightStatus?.status | lowercase).indexOf(
                      'not'
                    ) === -1
                      ? (resTodayTrip.flightStatus.status | lowercase)
                      : '--'
                  }}
                </div>
              </div>
            </div>
            <div class="col-7 col-sm-7 col-md-7 col-xl-7 col-lg-7 pl-3">
              <div class="flight-labels status-gate">
                {{ resTodayTripContent?.gateLabel }}
              </div>
              <div class="mt-1">
                <span class="gate-code">
                  {{
                    resTodayTrip.flightStatus && resTodayTrip.flightStatus.gate
                      ? resTodayTrip.flightStatus.gate
                      : '--'
                  }}
                </span>
                <span class="depart-arrive domestic-term pl-1">
                  {{ resTodayTrip?.flightStatus?.terminal }}
                </span>
              </div>
            </div>
          </div>
          <div class="row no-gutters flyout-details">
            <span
              *ngIf="resAcctSumDetails.skyPriority"
              aria-label="Sky Priority"
              class="sky-priority"
            ></span>
            <!--<span class="sr-only">Sky Priority</span>-->
            <div class="col-7 col-sm-7 col-md-7 col-xl-7 col-lg-7">
              <div
                class="flyout-label pb-2 text-left member-type text-uppercase"
              >
                {{ getMemberDesc }}
              </div>
              <div class="flyout-value">
                {{ resAcctSumDetails.firstName }}
                {{
                  resAcctSumDetails.middleName
                    ? resAcctSumDetails.middleName
                    : ''
                }}
                {{ resAcctSumDetails.lastName }}
              </div>
            </div>
            <div class="col-5 col-sm-5 col-md-5 col-xl-5 col-lg-5">
              <div class="flyout-label pb-2 text-left seat-label">
                {{ resTodayTripContent?.seatLabel }}
              </div>
              <div class="flyout-value">
                {{ resTodayTrip.seatNumber ? resTodayTrip.seatNumber : '--' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section *ngIf="showIropModel && resTodayTripContent" class="irop-model">
      <div
        [ngClass]="
          getStatusColorChange(
            resTodayTrip.flightStatus && resTodayTrip.flightStatus.statusColor
              ? resTodayTrip.flightStatus.statusColor
              : null
          )
        "
        class="irop-model-highlight"
      ></div>
      <div
        [ngClass]="{ 'today-vs-align': !isDelta }"
        class="vs-today-irop"
      ></div>
      <div
        #iropmsg
        *ngIf="iropErrorMsg"
        [ngClass]="getIROPColorChange(resTodayTrip.iropMessage)"
        class="mr-5 ml-5 irop-status-message"
        id="irop_msg"
        role="alert"
        tabindex="0"
      >
        <div class="mr-2 irop-error-icon">
          <img
            alt="irop status icon"
            class="irop-status"
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          />
        </div>
        <h3 class="irop-heading">{{ iropErrorMsg.errorMessageTitle }}</h3>

        <div class="irop-message">
          {{ iropErrorMsg.errorMessageDescription }}
        </div>
      </div>
      <div class="row no-gutters pl-5 irop-button-container">
        <a
          (click)="closeIropModel()"
          *ngIf="resTodayTrip.remainOnFlight"
          class="flyout-button checkIn remain-same"
          href="javascript:void(0)"
          role="button"
        >
          {{ resTodayTripContent?.remainOnFlight | uppercase }}
        </a>

        <a
          (click)="mytripsTodayClick($event)"
          *ngIf="resTodayTrip.viewTripDetails && !disableViewLink"
          [attr.target]="
            resTodayTripContent?.viewTripDetailsOpenNewTab === 'true'
              ? '_blank'
              : '_self'
          "
          class="flyout-button checkIn view-trip-button"
          href="javascript:void(0)"
          role="button"
        >
          {{ resTodayTripContent?.viewTripDetails | uppercase }}
          <span class="sr-only">Open in same window</span>
          <span
            *ngIf="
              resTodayTripContent?.viewTripDetailsOpenNewTab === 'true';
              else viewTripDetailsOpenSameTab
            "
            class="sr-only"
          >
            Open in new window
          </span>
          <ng-template #viewTripDetailsOpenSameTab>
            <span class="sr-only">Open in same window</span>
          </ng-template>
          <form
            #flyoutTodayMytripsForm
            [action]="formActionFlight"
            id="flyout-todayTrip-link"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ resTodayTrip?.recordLocator }}"
            />
            <input
              name="firstName"
              type="hidden"
              value="{{ resTodayTrip?.firstName }}"
            />
            <input
              name="lastName"
              type="hidden"
              value="{{ resTodayTrip?.lastName }}"
            />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
        </a>
        <button
          class="flyout-button alternate-button pt-0 mb-lg-3"
          id="btnSubmit"
          *ngIf="resTodayTrip.findOtherFlights && awsFlag"
          (click)="findAlternateFlight()"
        >
          {{ resTodayTripContent?.findAlternate }}
          <span
            *ngIf="
              resTodayTripContent?.findAlternateOpenNewTab === 'true';
              else findAlternateOpenSameTab
            "
            class="sr-only"
          >
            Open in new window
          </span>
          <ng-template #findAlternateOpenSameTab>
            <span class="sr-only">Open in same window</span>
          </ng-template>
        </button>
        <form
          (ngSubmit)="onSubmit($event)"
          *ngIf="resTodayTrip.findOtherFlights && !awsFlag"
          [action]="formAction"
          [attr.target]="
            resTodayTripContent?.findAlternateOpenNewTab === 'true'
              ? '_blank'
              : '_self'
          "
          method="POST"
          novalidate
        >
          <button
            class="flyout-button alternate-button pt-0 mb-lg-3"
            id="btnSubmit"
            type="submit"
            *ngIf="resTodayTrip.findOtherFlights"
          >
            {{ resTodayTripContent?.findAlternate }}
            <span
              *ngIf="
                resTodayTripContent?.findAlternateOpenNewTab === 'true';
                else findAlternateOpenSameTab
              "
              class="sr-only"
            >
              Open in new window
            </span>
            <ng-template #findAlternateOpenSameTab>
              <span class="sr-only">Open in same window</span>
            </ng-template>
          </button>
          <input
            id="recordLocator"
            name="recordLocator"
            type="hidden"
            value="{{ resTodayTrip?.recordLocator }}"
          />
          <input
            id="firstName"
            name="firstName"
            type="hidden"
            value="{{ resTodayTrip?.firstName }}"
          />
          <input
            id="lastName"
            name="lastName"
            type="hidden"
            value="{{ resTodayTrip?.lastName }}"
          />
        </form>
      </div>
      <button
        (click)="closeIropModel()"
        *ngIf="!hideIROPClose"
        class="irop-flyout-close float-right circle-outline"
        type="button"
      >
        <span class="sr-only">close</span>
      </button>
    </section>
  </section>
  <section
    *ngIf="
      !resTodayTrip &&
      noUpcomingTripContent &&
      aemErrorMsgDetails &&
      resTodayTripContent
    "
    class="no-upcoming-trips-section h-100 d-flex align-items-center text-center"
    tabindex="1"
  >
    <div class="row w-100">
      <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
        <div class="w-100 ml-2 mr-2" tabindex="0">
          <img
            alt="Flight Icon"
            aria-labelledby="Flight Icon"
            class="round-flight-icon"
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          />
          <p class="mb-3 mt-4">
            {{ aemErrorMsgDetails?.errorMessageDescription }}
          </p>
          <p class="mb-0">
            <a
              (click)="tripNavItem('book')"
              class="link-to-book"
              href="javascript:void(0);"
              role="link"
            >
              {{ resTodayTripContent?.bookFlightLink }}
            </a>
            <span class="va-notrip-space">or</span>
            <a
              (click)="tripNavItem('mytrips')"
              (keydown.tab)="focusOutFunctionAx($event)"
              class="link-to-mytrips"
              href="javascript:void(0);"
              role="link"
            >
              {{ resTodayTripContent?.myTripsLink }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    *ngIf="!resTodayTrip && !noUpcomingTripContent && aemErrorMsgDetails"
    class="no-upcoming-trips-section d-flex align-items-center text-center"
    tabindex="1"
  >
    <div [ngClass]="{ 'today-vs-align': !isDelta }" class="vs-today-irop">
      <div class="acctvty-error-container container-fluid p-0">
        <div class="col text-center service-error-content mt-fix p-0">
          <p>
            <span class="icon-alert-icon">
              <span class="path1"></span>
              <span class="path2"></span>
            </span>
            {{ aemErrorMsgDetails?.errorMessageDescription }}.
          </p>
        </div>
      </div>
    </div>
  </section>
</ng-template>
<div *ngIf="spinner" class="spinner-overlay"></div>
<div *ngIf="spinner" class="spinner-loading">
  <div class="loader-holder"></div>
  <h2>Loading...</h2>
</div>
